import React from "react";

import InfoGraphicMobilePtBr from "@src/assets/novo-fluxo-sagres-mobile.png";
import InfoGraphicPtBr from "@src/assets/novo-fluxo-sagres.png";

import infoGraphicEnUs from "@src/assets/novo-infoGraphicEnUs.png";
import infoGraphicEnUsMobile from "@src/assets/novo-infoGraphicEnUsMobile.png";

import infoGraphicEs from "@src/assets/novo-infoGraphicEs.png";
import infoGraphicEsMobile from "@src/assets/novo-infoGraphicEsMobile.png";

// import infoGraphicEs from "@src/assets/infoGraphicEs.svg";
// import infoGraphicEsMobile from "@src/assets/infoGraphicEsMobile.svg";

import useDimensoes from "@src/hooks/useDimensoes";
import { useIdioma } from "@src/hooks/useLang";

const InfoGrafico = () => {
  const [width, height] = useDimensoes();
  const { idioma } = useIdioma();

  const renderizarInfoGraficoEspanhol = () => {
    return width < 1400 ? (
      <img src={infoGraphicEsMobile} className="oimg" />
    ) : (
      <img src={infoGraphicEs} className="oimg" />
    );
  };

  if (idioma === "pt-BR") {
    return width < 1400 ? (
      <img src={InfoGraphicMobilePtBr} className="oimg" />
    ) : (
      <img src={InfoGraphicPtBr} className="oimg" />
    );
  }

  if (idioma === "en-US") {
    return width < 1400 ? (
      <img src={infoGraphicEnUsMobile} className="oimg" />
    ) : (
      <img src={infoGraphicEnUs} className="oimg" />
    );
  }

  return renderizarInfoGraficoEspanhol();
};
export default InfoGrafico;
